import React from 'react';
import { withRouter } from "react-router-dom";
import BusinessNameComponent from './BusinessNameComponent';


const BusinessNameLanding = () => {
    return <BusinessNameComponent />
}
export default withRouter(BusinessNameLanding);